import React from "react";
import { X } from "lucide-react";

export default function AdminModal({ open, onClose, title, maxWidth = "max-w-md", children, footer, testId }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-hv-navy/40 backdrop-blur-sm p-4" onClick={onClose}>
      <div
        data-testid={testId}
        className={`w-full ${maxWidth} bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-[#E5DFC8]">
          <h3 className="hv-heading text-lg text-hv-navy">{title}</h3>
          <button type="button" onClick={onClose} className="text-hv-slate hover:text-hv-navy">
            <X size={18} />
          </button>
        </div>
        <div className="p-5 space-y-3">{children}</div>
        {footer && <div className="px-5 pb-5 flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
